import { render, staticRenderFns } from "./green-section.vue?vue&type=template&id=84354da8"
var script = {}
import style0 from "./green-section.vue?vue&type=style&index=0&id=84354da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports